import { render, staticRenderFns } from "./cascader-panel.vue?vue&type=template&id=48248b1e&"
import script from "./cascader-panel.vue?vue&type=script&lang=js&"
export * from "./cascader-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports